import React from 'react';

export default function Button({
  variant = 'primary',
  size = 'lg',
  fullWidth = false,
  className = '',
  children,
  ...props
}) {
  const base = 'yk-btn';
  const variantClass = variant ? `yk-btn--${variant}` : '';
  const sizeClass = size ? `yk-btn--${size}` : '';
  const widthClass = fullWidth ? 'yk-btn--full' : '';

  return (
    <button
      {...props}
      className={[base, variantClass, sizeClass, widthClass, className].filter(Boolean).join(' ')}
    >
      {children}
    </button>
  );
}
